import Expired from './Expired.gql';

export default Expired;
